import { render, staticRenderFns } from "./ByName.vue?vue&type=template&id=36528f94"
import script from "./ByName.vue?vue&type=script&lang=js"
export * from "./ByName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports